<template>
  <Teleport to="body">
    <div v-if="show" class="fixed inset-0 z-[100] flex items-center justify-center">
      <div class="absolute inset-0 bg-black/50" @click="$emit('close')" />
      <div class="relative z-10 bg-white rounded-lg p-6 w-full max-w-md mx-4 shadow-xl">
        <h3 class="text-xl font-semibold text-gray-900 mb-2">Please enter your phone number</h3>
        <p class="text-sm text-gray-700 mb-4">We'll include it in your appointment request email.</p>
        <input
          ref="inputRef"
          :value="phone"
          type="tel"
          placeholder="(555) 555-5555"
          class="w-full border border-gray-300 rounded-md px-4 py-3 text-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          @input="onInput"
          @keyup.enter="submit"
        />
        <div class="flex gap-3 mt-5">
          <button
            class="flex-1 px-4 py-3 rounded-md bg-gray-200 text-gray-900 hover:bg-gray-300 transition-colors font-medium"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            class="flex-1 px-4 py-3 rounded-md transition-colors font-medium"
            :class="isComplete ? 'bg-gray-900 text-white hover:bg-gray-800' : 'bg-gray-300 text-gray-500 cursor-not-allowed'"
            :disabled="!isComplete"
            @click="submit"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close", "submit"]);

const phone = ref("");
const inputRef = ref(null);

const isComplete = computed(() => {
  return phone.value.replace(/\D/g, "").length === 10;
});

const formatPhone = (digits) => {
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

const onInput = (e) => {
  const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
  phone.value = digits.length ? formatPhone(digits) : "";
  nextTick(() => {
    e.target.value = phone.value;
  });
};

watch(
  () => props.show,
  (val) => {
    if (val) {
      nextTick(() => inputRef.value?.focus());
    } else {
      phone.value = "";
    }
  }
);

const submit = () => {
  if (!isComplete.value) return;
  const mailto = `mailto:info@mrhsclinics.com?subject=Appointment Request for MRHS | Big Leap Health&body=Hello, I would like to book an appointment. %0D%0A%0D%0APhone Number: ${encodeURIComponent(phone.value)}%0D%0A%0D%0A&bcc=info@bigleaphealth.com`;
  window.location.href = mailto;
  emit("submit");
  emit("close");
};
</script>
